export default function HeatingSavings() {
  const checks = [
    "Un joint défectueux peut faire perdre jusqu'à 30% de l'isolation de la fenêtre",
    "Une fenêtre mal fermée augmente la consommation de chauffage de 10 à 15%",
    "Le réglage des points de compression rétablit l'étanchéité instantanément",
    "Le remplacement des joints coûte 20 à 40 fois moins cher qu'une fenêtre neuve",
    "Une bonne étanchéité réduit aussi les nuisances sonores extérieures",
    "L'intervention dure 1h à 2h et vous fait économiser dès le premier jour",
  ];

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Économies concrètes
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            Économies de chauffage{" "}
            <span className="font-serif italic">à la clé</span>
          </h2>

          <div className="space-y-6 text-plum-dark text-base md:text-lg leading-relaxed mb-10">
            <p>
              Une fenêtre qui ferme mal, ce n'est pas seulement un inconfort : c'est une véritable fuite thermique qui impacte directement votre facture de chauffage. L'air froid qui s'infiltre par les interstices force votre chaudière ou votre pompe à chaleur à travailler plus. Une étude thermique simple montre qu'un joint de fenêtre défectueux peut représenter une perte de 15 à 25% de l'efficacité énergétique de l'ouvrant. Multipliez par le nombre de fenêtres concernées dans une maison, et vous comprenez l'impact sur votre portefeuille.
            </p>
            <p>
              Notre intervention de réglage et de réparation des joints permet de restaurer l'étanchéité d'origine de votre fenêtre. Les points de compression sont réajustés pour comprimer uniformément le joint, les galets de fermeture sont réglés au millimètre près, et les joints usés sont remplacés par des pièces neuves de même qualité. Le résultat est immédiat : plus de courant d'air, une fermeture douce et silencieuse, et une réduction sensible de votre consommation énergétique. C'est un investissement qui se rentabilise en une seule saison de chauffage.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-rose-200 p-6 md:p-8">
            <h3 className="font-semibold text-plum text-base md:text-lg mb-5">
              Pourquoi réparer une fenêtre qui ferme mal est rentable
            </h3>
            <ul className="space-y-3">
              {checks.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-coral/10 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-coral text-sm" />
                  </div>
                  <span className="text-sm md:text-base text-plum-dark">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}